import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { handleRecruiter, Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petition-comment',
		path: '/p/:slug/c/:id',
		component: loadable(async () => import(/* webpackChunkName: "pages/petitionComment" */ './index'), {
			exportName: 'PetitionComment',
			fallback: Loading,
		}),
		frame: true,
		beforeServerRender: async (context) => {
			await handleRecruiter(context, context.params.slug);
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
